<template>
  <div class="app-breadcrumb-wrap content-breadcrumb-layout">
    <el-breadcrumb class="app-breadcrumb-left" separator="/" v-if="breadcrumb && breadcrumb.length">
      <div class="inner-breadcrumb">
        <el-breadcrumb-item
          v-for="(item, ind) in breadcrumb"
          :key="item.name + item.path + ind"
          :to="getPath(item)">
          <span class="separator" v-if="(ind !== 0) && item.name">/</span>
          {{ item.name }}
        </el-breadcrumb-item>
      </div>
    </el-breadcrumb>
  </div>
</template>
<script>
// import { getToken, setToken, setTenantId, gotoNewWindow } from '../utils'
import { mapGetters } from 'vuex'
// import * as multiTenantConfig from '../api'
// import Cookies from 'js-cookie'
// import { brandUtils } from 'blm-utils'
export default {
  computed: {
    ...mapGetters(['breadcrumb']),
    // newTenantList () {
    //   this.brandList.map(item => {
    //     item.type = 'brand'
    //     item.tenantName = this.filterBracket(item.tenantName)
    //   })
    //   const list = [...this.brandList]; const tenantId = this.userInfo.tenantId

    //   // 如果是租牌模式，去除当前租户的
    //   this.tenantList.forEach((item) => {
    //     if (item.tenantId !== tenantId) {
    //       list.push({
    //         ...item,
    //         type: 'tenant',
    //         isTenant: true,
    //         tenantName: `${item.tenantName}[${item.tenantId}]`
    //       })
    //     }
    //   })
    //   return list
    // },
    // cuBrandId: {
    //   get () {
    //     const bid = this.$store.state.global.brandId
    //     const n_bid = Number(bid)
    //     return Number.isNaN(n_bid) ? bid : n_bid
    //   },
    //   set (n) {
    //     this.$store.commit('SET_BRAND_ID', n)
    //   }
    // },
    // isCcs () {
    //   return this.platForm === 'ccs'
    // }
  },
  data() {
    return {
      // platForm: '',
      // hasView: false,
      // selectIsLoading: false,
      // currentTenantId: null,
      // tenantList: [],
      // currentDailyEnv: Cookies.get('dailyEnv') || 'daily',
      // isDaily: /^admin-daily\./.test(window.location.hostname),
      // tenantId: this.$route.query.currentTenantId,
      // isManualControl: false, // 是否手动切换租户
      // tourOptions: {
      //   labels: {
      //     buttonStop: '我知道了'
      //   }
      // },
      // steps: [
      //   {
      //     target: '.app-breadcrumb-right', // We're using document.querySelector() under the hood
      //     content: '品牌切换放这里了',
      //     header: {
      //       title: '提示'
      //     }
      //   }
      // ]
    }
  },
  // watch: {
  //   userInfo (val) {
  //     const _this = this
  //     if (val && val.tenantId && !_this.hasView) {
  //       _this.viewInit()
  //     }
  //   }
  //   currentTenantId (val) {
  //     const _this = this
  //     if (val !== _this.userInfo.tenantId) {
  //       val && val !== _this.userInfo.tenantId && (_this.changeTenant(val))
  //     }
  //   }
  //   '$route': {
  //     handler () {
  //       this.platForm = location.pathname.split('/')[1]
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // filterBracket (str) {
    //   const preIndexOf = str.indexOf('（')
    //   const sufIndexOf = str.indexOf('）')
    //   if (preIndexOf !== -1 && sufIndexOf !== -1) {
    //     const sliceTxt = str.slice(preIndexOf, sufIndexOf + 1)
    //     return str.replace(sliceTxt, '')
    //   } else {
    //     return str
    //   }
    // },
    // 页面初始化
    // viewInit () {
    //   const _this = this
    //   _this.hasView = true
    //   _this.currentTenantId = _this.tenantId ? Number(_this.tenantId) : _this.userInfo.tenantId
    // },
    // 更改租户信息
    // changeTenant (tenantId) {
    //   const _this = this
    //   const tmpParams = {
    //     token: getToken(),
    //     tenantId: tenantId
    //   }
    //   multiTenantConfig.changeTenant(this.request, tmpParams)
    //     .then(response => {
    //       const data = response.data
    //       const userInfo = data.userVO || {}
    //       const tenantId = userInfo.tenantId || -1
    //       setToken({ token: data.token, expiration: data.expiration })
    //       setTenantId(tenantId)
    //       // 清理租牌相关 sessionStorage
    //       _this.cleanSession()

    //       sessionStorage.TEMP_TENANTID = tenantId

    //       // 如果是租户清除hash、session、local
    //       brandUtils.setBrandId('')

    //       // 地址栏有租户id且不是手动操作 重新加载页面
    //       if (_this.tenantId && !_this.isManualControl) {
    //         _this.handleSetSession()
    //         window.location.reload()
    //       } else {
    //         gotoNewWindow()
    //       }
    //     })
    //     .catch(err => {
    //       sessionStorage.removeItem('TEMP_TENANTID')
    //       this.$store.dispatch('FedLogOut')
    //       brandUtils.setBrandId('')
    //       setTenantId('')
    //       Promise.reject({
    //         monitor: true,
    //         msg: `Failed to switch tenants . Message:${err} ,  target: ${tenantId}  from: ${this.userInfo.tenantId} userAccount: ${this.userInfo.userAccount}`
    //       }).then()

    //       this.$message({
    //         message: '切换租户失败将返回登录页',
    //         type: 'error'
    //       })

    //       setTimeout(() => {
    //         location.href = '/'
    //       }, 2000)
    //     })
    // },
    // cleanSession () {
    //   sessionStorage && sessionStorage.setItem('sessionEid', '');
    //   sessionStorage && sessionStorage.setItem('sessionAdcode', '');
    // },
    // handleSetSession () {
    //   const { brandId } = this.$route.query
    //   if (brandId) {
    //     sessionStorage && sessionStorage.setItem('sessionEid', brandId);
    //   }
    // },
    // 设置跳转路径，微前端下需要添加base 项目名
    getPath(item) {
      return item.path ? item.path : null
    },
    // setBrandId (tenantId, route) {
    //   window[brandUtils.windowKey] = tenantId
    //   localStorage[brandUtils.SessionKey] = sessionStorage[brandUtils.SessionKey] = tenantId
    //   Cookies.set('_brand_id', tenantId)
    //   this.cleanSession()
    //   // eslint-disable-next-line no-unused-vars
    //   const { fullPath, matched, hash, ...other } = (route || this.$route)
    //   let ops
    //   if (route) {
    //     ops = {
    //       path: `/${location.pathname.split('/')[1]}${other.path}`,
    //       query: route.query || {}
    //     }
    //   } else {
    //     ops = other
    //   }
    //   this.$router.replace({
    //     ...ops,
    //     hash: brandUtils.HashKey + tenantId
    //   })

    //   this.$store.commit('SET_BRAND_ID', tenantId)
    //   this.$nextTick(brandUtils.dispatch)
    // }
    // goHome () {
    //   if (window.__POWERED_BY_QIANKUN__) {
    //     this.$router.push('/' + location.pathname.split('/')[1])
    //   } else {
    //     this.$router.push('/')
    //   }
    // }
  },
  // created () {
  //   window.SET_BRAND_ID = this.setBrandId
  // },
  // mounted () {
  //   this.viewInit()
  //   if (!localStorage.getItem('layoutBrandTour') && this.newTenantList.length > 1 && !this.isCcs) {
  //     this.$refs.myTour.start()
  //     localStorage.setItem('layoutBrandTour', 1)
  //   }
  // }
}
</script>

<style lang="scss">
.app-breadcrumb-wrap{
  display:flex;
  flex-grow: 1;
  align-items: center;
  flex-direction: row;
  padding:1px 15px;
  border: none;
  .inner-breadcrumb {
    display: flex;
    .el-breadcrumb__separator {
      display: none;
    }
    .separator {
      padding: 0 4px 0 8px;
      font-weight: normal;
      color: #606266;
    }
    .el-breadcrumb__inner {
      color: #969799;
      max-width: none;
      a,
      &.is-link {
        font-weight: normal;
        // color: #323233;
        &:hover {
          color: #2e7eff;
        }
      }
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #323233;
    }
  }
  .app-breadcrumb-env{
    flex:1;
  }
  .app-breadcrumb-left{
   flex:1;
    &.el-breadcrumb {
      // display: flex;
      overflow: hidden;
      font-size: 14px;
      line-height: 30px;
      .no-redirect {
        // color: #97a8be;
        cursor: text;
      }
      .el-breadcrumb__item {
        flex-shrink: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-child,
        &:last-child {
          flex-shrink: 0;
        }
        &:nth-last-child(2) {
          flex-shrink: 1;
        }
        // &:last-child {
        //   padding-right: 16px;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   white-space: nowrap;
        //   max-width: 240px;
        // }
      }
    }
  }
  .app-breadcrumb-right {
    margin-right: 18px;
    width: 175px;
    .brand-select{
      .el-input__inner{
        border: none;
        background: #F6F7FB;
        border-radius: 16px;
        color: #323233;
        padding-left:60px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-input__inner::-webkit-input-placeholder {
        color: #323233;
      }
      .el-select__caret{
        color: #9A9A9A;
      }
      .el-input__prefix{
          color: #656566;
          padding-left:10px;
      }
    }
  }
  .a-link {
    cursor: pointer !important;
    font-weight: 700 !important;
    color: #303133 !important;
  }
}
.app-breadcrumb-brand{
  padding: 0;
  >li{
    list-style: none;
    i{
      float: right;
      margin-top: 3px;
      display: none;
    }
  }
  >li.active{
    color: #409EFF;
    font-weight: 700;
    i{
      display: block;
    }
  }
}
.tenant-List{
  min-width: 175px;
  max-width: 240px;
  .el-divider--horizontal{
    margin: 15px 0;
  }
  .el-select-dropdown__item{
    cursor: default;
    padding: 0;
    height: auto;
  }
  .el-select-dropdown__item.selected{
    color:#2E7EFF;
    font-weight: normal;
    background-color: inherit;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: inherit;
  }
  .divider{
    padding: 0 20px;
    box-sizing: border-box;
    .el-divider__text{
      padding: 0 5px;
      font-size:12px;
      color:#969799;
      font-weight: normal;
      .point{
        padding: 0 2px
      }
    }
  }
}
</style>
